import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../services/local-storage';
import { SharedNameService } from '../../services/sharedName.service';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import {User} from '../../models/user';
import { LoaderService } from '../../services/Spinner.service';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupLogComponent } from '../../advertiser/popup/popup-log.component';

@Component({
  selector: 'app-adv-header',
  templateUrl: './adv-header.component.html',
  styleUrls: ['./adv-header.component.css'],
  providers: [PopupLogComponent,SharedNameService]
})
export class AdvHeaderComponent implements OnInit {
  user = new User();
  profileUrl:string;
  name:string;
  headerData;

  constructor(private sharedNameService: SharedNameService,private localstorage : LocalStorage,private router: Router,private shareService :SharedService, private loaderService : LoaderService,private PopupSignup: PopupLogComponent, private dialogService:DialogService) { 
    this.headerData = this.sharedNameService.sharedData;
  }
  ngOnInit() {
    
    
    console.log("this.headerData"+this.headerData.name);
    var token=this.localstorage.getStorage('token');
    if(token){
      this.shareService.CallDatawithToken("adv/profile/", null, token).subscribe((result) => {
            if(result){
              this.headerData.name=result.data.companyName;
              console.log(result.data.profileUrl.indexOf("user"));
              if(result.data.profileUrl.indexOf("user") !== -1){
                      this.profileUrl = result.data.profileUrl;
                      this.headerData.image = result.data.profileUrl;
              }
              else{
                this.profileUrl = undefined;
                      this.headerData.image = undefined;

              }
              console.log(this.headerData.image);
              console.log(this.profileUrl);
              this.sharedNameService.sharedData = this.headerData;
            }else{
              this.loaderService.displayLoader(false);
            }

      });
    }
    this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.user.objLoaderStatus = val;
    });
  }
  showConfirm() {
            let disposable = this.dialogService.addDialog(PopupLogComponent, {
                title:'Logout', 
                message:'Are you sure you want to logout?'})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    if(isConfirmed) {
                    this.loaderService.displayLoader(true);
                    var token=this.localstorage.getStorage('token');
                    this.shareService.callApiWithToken("adv/profile/signOut",null,token).subscribe((result) => {
                            if(result.meta.code==401){
                              this.loaderService.displayLoader(false);
                              this.localstorage.removeStorage('token');
                              this.localstorage.removeStorage('start');
                              this.localstorage.removeStorage('selectedSegements');
                              this.localstorage.removeStorage('usertype');
                              this.localstorage.removeStorage('campaignId');
                              this.localstorage.removeStorage("payreceipt");
                              this.localstorage.removeStorage("pay");
                              this.loaderService.displayLoader(false);
                              this.router.navigate(['advertiser/adlogin']);
                            }else{
                            if(result){
                              if(result.data.status){
                                  this.loaderService.displayLoader(false);
                                  this.localstorage.removeStorage('token');
                                  this.localstorage.removeStorage('start');
                                  this.localstorage.removeStorage('selectedSegements');
                                  this.localstorage.removeStorage('usertype');
                                  this.localstorage.removeStorage('campaignId');
                                  this.localstorage.removeStorage("payreceipt");
                                  this.localstorage.removeStorage("pay");
                                  this.router.navigate(['advertiser/adlogin']);
                                  //  window.location.reload();
                              }
                            }else{
                              this.loaderService.displayLoader(false);
                            }
                          }
                            // this.loaderService.displayLoader(false);
                      });
                    }
                    else {
                        console.log("declined");   
                    }
                });
            //We can close dialog calling disposable.unsubscribe();
            //If dialog was not closed manually close it by timeout
        }
        redirectpage() {
     var token=this.localstorage.getStorage('token');
     if(token) {
    this.router.navigate(['advertiser/campaignlist']); 
     }
     else {
       this.router.navigate(['']); 
     } 
  }
  logout() {
    this.showConfirm();
  }
  checkimageURL(url) {
        if (url) {
            return (url.match(/\.(jpeg|jpg|JPG|gif|png)$/) != null);
        }

    }
    getPay () {
      this.localstorage.setStorage("pay","1")
    }
}



// WEBPACK FOOTER //
// ./src/app/common/adv-header/adv-header.component.ts